import { render } from "./search-sort.vue?vue&type=template&id=640f6788"
import script from "./search-sort.js?vue&type=script&lang=js"
export * from "./search-sort.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__